import { logger } from "@platform/browser-logger";
import camelCase from "lodash/camelCase";

export const MIN_COLUMN_WIDTH = 450;

interface ClipboardCellDef {
  cellEditor?: string;
  cellEditorParams?: { values?: string[] };
  field?: string;
}

/**
 * Processes pasted clipboard values for dropdown cells by normalising
 * to camelCase and rejecting values not in the allowed list.
 */
export const processCellFromClipboard = (
  node: { data?: { meta?: { cellDef?: ClipboardCellDef } } } | null | undefined,
  value: unknown,
): unknown => {
  if (typeof value !== "string") return value;

  const cellDef: ClipboardCellDef | undefined = node?.data?.meta?.cellDef;
  if (!cellDef) return value;

  const isDropdownCell =
    cellDef.cellEditor === "agRichSelectCellEditor" ||
    cellDef.cellEditor === "agSelectCellEditor";
  if (!isDropdownCell) return value;

  const allowedValues: string[] = cellDef.cellEditorParams?.values ?? [];
  if (allowedValues.length === 0) return value;

  const camelCasedValue = camelCase(value);
  if (!allowedValues.includes(camelCasedValue)) {
    logger.warn(
      "[PlanEditor] Pasted value rejected - not in dropdown options",
      { field: cellDef.field, value, allowedValues },
    );
    return undefined;
  }
  return camelCasedValue;
};
